export default function getResource(label, vars = []) {
    const resources = {
        yearAtGlanceTitle: `${vars[0]} at a Glance`,
        yearAtGlanceError: 'We couldn\'t load your annual history right now.',
        yearAtGlanceSignedOut: `Sign in to access your ${vars[0]} at a Glance.`,
        yearAtGlanceNonBi: `Join to access your ${vars[0]} at a Glance.`,
        yearAtGlanceEmpty: `Your ${vars[0]} earnings will appear here. Keep shopping to get rewards, benefits, and discounts!`,
        shopNow: 'Shop Now',
        employeeDiscountPurchase: 'Employee Discount Purchase',
        promosAndDiscountApplied: 'Promos & Discount Applied',
        beautyInsiderCashApplied: 'Beauty Insider Cash Applied',
        creditCardRewardsEarned: 'Credit Card Rewards Earned',
        rougeRewardsEarned: 'Rouge Rewards Earned'
    };

    return resources[label];
}
